var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 114,
    viewBox: "0 0 188 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5714 67.0001H49.2857M49.2857 40.4287H137.857C154.42 40.4287 162.693 40.4287 168.857 43.9893C172.896 46.3213 176.25 49.6754 178.582 53.7144C182.143 59.879 182.143 68.1516 182.143 84.7144C182.143 101.277 182.143 109.55 178.582 115.714C176.25 119.753 172.896 123.108 168.857 125.44C162.693 129 154.42 129 137.857 129H134.367C128.283 129 125.245 129 122.401 128.371C118.591 127.525 115.013 125.85 111.923 123.464C109.621 121.675 107.672 119.346 103.775 114.669C100.675 110.949 99.116 109.089 97.3357 108.248C96.1579 107.695 94.8726 107.408 93.5714 107.408C92.2702 107.408 90.985 107.695 89.8071 108.248C88.0269 109.08 86.4768 110.94 83.368 114.669C79.4708 119.346 77.5223 121.675 75.2194 123.464C72.1296 125.85 68.5521 127.525 64.7414 128.371C61.9071 129 58.8603 129 52.7754 129H49.2857C32.7229 129 24.4503 129 18.2857 125.44C14.2467 123.108 10.8926 119.753 8.56057 115.714C5 109.55 5 101.277 5 84.7144C5 68.1516 5 59.879 8.56057 53.7144C10.8926 49.6754 14.2467 46.3213 18.2857 43.9893C24.4503 40.4287 32.7229 40.4287 49.2857 40.4287Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.143 75.8571V65.4766C182.143 55.2643 182.143 50.1537 180.788 45.3886C180.04 42.7736 178.994 40.2534 177.67 37.8777C175.27 33.5554 171.647 29.9417 164.429 22.7143C157.21 15.4869 153.587 11.8731 149.265 9.47286C146.889 8.14877 144.369 7.10264 141.754 6.35514C136.989 5 131.879 5 121.666 5H65.4766C55.2643 5 50.1537 5 45.3886 6.35514C42.7736 7.10264 40.2534 8.14877 37.8777 9.47286C33.5554 11.8731 29.9417 15.4957 22.7143 22.7143C15.4869 29.9329 11.8731 33.5554 9.47286 37.8777C8.14877 40.2534 7.10265 42.7736 6.35514 45.3886C5 50.1537 5 55.2643 5 65.4766V75.8571",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon4);
export default __webpack_public_path__ + "static/media/about-icon4.f45d5aed8d4d73dc0f5c1cdf3c788ae0.svg";
export { ForwardRef as ReactComponent };